<script>
    export let title = "";
    export let content = "";
    export let showContent = true;
</script>

<div class={`flex flex-row gap-x-2 ${showContent ? "" : "hidden"}`}>
    <p class="title">{title}:</p>
    <p class="content">{content}</p>
</div>

<style>
    .title {
        width: 200px;
    }

    .content {
        width: calc(100% - 200px);
    }
</style>
